import {baseConfig} from '../helpers/baseConfig'
import colors from '../../../../theme/foundations/colors'

export const cardConfig = (props) => {
    const cardDetails = {
        endDigits: '',
        issuerBin: ''
    }
    return {
        ...baseConfig({
            ...props,
            cardDetails
        }),
        _disableClickToPay: true,
        showPayButton: true,
        hasHolderName: true,
        holderNameRequired: true,
        billingAddressRequired: false,
        enableStoreDetails: false,
        styles: {
            base: {
                fontSize: '12px'
            },
            placeholder: {
                transition: 'inherit',
                fontSize: '12px',
                color: colors.darkGray
            },
            error: {
                color: colors.red
            }
        },
        onLoad: () => {
            const creditCardImageElement = document.querySelector(
                '.adyen-checkout__payment-method:first-child .adyen-checkout__payment-method__image__wrapper'
            )
            const creditCardImages = document.querySelector('.adyen-checkout__card__brands')
            if (creditCardImageElement && creditCardImages) {
                creditCardImageElement.innerHTML = creditCardImages.innerHTML
                creditCardImageElement.style.opacity = 1
                creditCardImages.remove()
            }
        },
        onFieldValid: (field) => {
            if (field?.fieldType === 'encryptedCardNumber') {
                cardDetails.endDigits = String(field.endDigits) || ''
                cardDetails.issuerBin = String(field.issuerBin) || ''
            }
            return
        }
    }
}
